module.exports = __webpack_public_path__ + "8b4c9047df3361c10cb6e98931089c55.pdf";